export default "__VITE_ASSET__BL4V6XlP__"